import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonios" className="py-24 px-6 bg-cream" data-id="element-267">
      <div className="max-w-4xl mx-auto text-center" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-269">
          <h2 className="text-3xl md:text-5xl font-serif text-ink mb-16" data-id="element-270">
            Lo que dicen quienes ya confiaron en Ingri
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-271">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-white p-8 border border-gold/20 rounded-sm shadow-sm relative" data-id="element-272">
            <div className="flex justify-center gap-1 mb-6" data-id="element-273">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-gold fill-gold" data-id="element-274" />)}
            </div>
            <p className="font-serif text-xl text-ink italic mb-6" data-id="element-275">
              "Estoy encantada con el trabajo de Ingri."
            </p>
            <div className="font-sans text-sm uppercase tracking-widest text-ink-light" data-id="element-276">
              Cliente verificada en Google
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 border border-gold/20 rounded-sm shadow-sm relative" data-id="element-277">
            <div className="flex justify-center gap-1 mb-6" data-id="element-278">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-gold fill-gold" data-id="element-279" />)}
            </div>
            <p className="font-serif text-xl text-ink italic mb-6" data-id="element-280">
              "¡Mis pestañas siempre quedan preciosas, nunca me decepciona!"
            </p>
            <div className="font-sans text-sm uppercase tracking-widest text-ink-light" data-id="element-281">
              Cliente verificada en Google
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="inline-flex items-center gap-4 bg-blush/30 border border-gold/20 text-ink-dark px-8 py-4 rounded-full font-sans text-sm tracking-wide shadow-sm" data-id="element-282">
          <div className="flex gap-1" data-id="element-283">
            <Star size={16} className="text-gold fill-gold" data-id="element-284" />
            <Star size={16} className="text-gold fill-gold" data-id="element-285" />
            <Star size={16} className="text-gold fill-gold" data-id="element-286" />
            <Star size={16} className="text-gold fill-gold" data-id="element-287" />
            <Star size={16} className="text-gold fill-gold" data-id="element-288" />
          </div>
          <span className="font-medium" data-id="element-289">
            5.0 estrellas en Google · 10 reseñas reales · Cero decepciones.
          </span>
        </motion.div>
      </div>
    </section>;
}